import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} GoLiveResponse
 * @property {boolean} success
 * @property {string | null} message
 * @property {object | null} data
 */

export const useGoLive = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [response, setResponse] = useState(
    /** @type {GoLiveResponse | null} */ (null),
  );

  const { axiosInstance } = useAxios();

  const triggerGoLive = async (payload = {}) => {
    try {
      setLoading(true);
      setError("");
      setResponse(null);

      const url = `${TENANT_DOMAIN}/billing/subscription-cycles/go-live`;

      const res = await axiosInstance.post(url, payload);

      const data = res?.data ?? null;

      // ✅ IMPORTANT FIX: handle business failure
      if (!data?.success) {
        const message = data?.message || ERROR_MESSAGES.UNKNOWN;

        setError(message);
        setResponse(data);

        return {
          success: false,
          message,
          data: null,
        };
      }

      // ✅ Success case
      setResponse(data);

      return {
        success: true,
        message: data?.message ?? null,
        data: data?.data ?? null,
      };
    } catch (err) {
      let message = ERROR_MESSAGES.UNKNOWN;

      if (err?.response?.status === 500) {
        message = ERROR_MESSAGES.INTERNAL_SERVER;
      } else if (err?.response?.data?.message) {
        message = err.response.data.message;
      }

      setError(message);
      setResponse(null);

      return {
        success: false,
        message,
        data: null,
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    response,
    triggerGoLive,
  };
};
